import React from "react";
import SkeletonLoading from "../SkeletonLoading/SkeletonLoading";
import "./NFTItem.css";

const NFTSkeleton = () => {
  return (
    <div className="nft-card">
      <div className="nft-card-content">
        {/* Title and Token ID Skeleton */}
        <div className="main mb-3 align-items-center nucin" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div className="left">
            <SkeletonLoading width={130} height={16} />
          </div>
          <div className="right block-typ">
            <div className="category-icon ms-auto">
              <SkeletonLoading width={38} height={24} style={{ borderRadius: "6px" }} />
            </div>
          </div>
        </div>

        {/* Image Skeleton */}
        <div className="image mb-3">
          <SkeletonLoading style={{ width: "100%", height: "260px", borderRadius: "16px" }} />
        </div>

        {/* Owner Info Skeleton */}
        <div className="owner-section mb-3" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <SkeletonLoading width={16} height={16} style={{ borderRadius: "4px" }} />
          <SkeletonLoading width={60} height={14} />
          <SkeletonLoading width={90} height={14} />
        </div>

        {/* Bottom Info - Price and Created Time Skeleton */}
        <div className="main align-items-center mb-3" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div className="left" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <SkeletonLoading width={35} height={11} />
            <SkeletonLoading width={75} height={20} />
          </div>
          <div className="right text-end" style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
            <SkeletonLoading width={70} height={11} />
            <SkeletonLoading width={90} height={14} />
          </div>
        </div>

        {/* Button Skeleton */}
        <div className="skeleton-button-wrapper">
          <SkeletonLoading style={{ width: "100%", height: "44px", borderRadius: "8px" }} />
        </div>
      </div>
    </div>
  );
};

export default NFTSkeleton;
